import { StyleSheet } from 'react-native';

export const createStyles = () => {
  return StyleSheet.create({
    container: {
      flex: 1,
    },
    header: {
      paddingHorizontal: 20,
      paddingTop: 16,
      borderBottomWidth: 1,
    },
    title: {
      fontSize: 24,
      fontWeight: 'bold',
      marginBottom: 16,
    },
    tabs: {
      flexDirection: 'row',
      gap: 24,
    },
    tab: {
      paddingVertical: 12,
      paddingHorizontal: 4,
    },
    tabText: {
      fontSize: 16,
      fontWeight: '600',
    },
    list: {
      padding: 16,
    },
    challengeCard: {
      borderRadius: 8,
      borderWidth: 1,
      padding: 12,
      marginBottom: 12,
    },
    messageContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginTop: 12,
      marginBottom: 8,
    },
    message: {
      fontSize: 14,
      flex: 1,
      fontStyle: 'italic',
    },
    statusRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 12,
      flexWrap: 'wrap',
      gap: 8,
    },
    statusBadge: {
      paddingHorizontal: 12,
      paddingVertical: 6,
      borderRadius: 12,
    },
    statusText: {
      fontSize: 12,
      fontWeight: '600',
      textTransform: 'capitalize',
    },
    actions: {
      flexDirection: 'row',
      gap: 8,
      flex: 1,
      justifyContent: 'flex-end',
    },
    tournamentLink: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
    },
    linkText: {
      fontSize: 14,
      fontWeight: '600',
    },
  });
};
